import { gql } from 'apollo-boost'

const DELETE_SCRAPING_SESSION_TEMPLATE = gql`
  mutation deleteScrapingSessionTemplate($id: ID!) {
    deleteScrapingSessionTemplate(id: $id)
  }
`

export default DELETE_SCRAPING_SESSION_TEMPLATE
